export const getInitialFormData = () => ({
  // Identity & Contact
  profilePhoto: "",
  fullName: "",
  dateOfBirth: "",
  mobileNo: "",
  mobileCode: "+91", // Default country code
  email: "",
  
  // Role & Assignment
  role: "",
  assignedHub: "",
  
  // Employment & Operations
  designation: "",
  joiningDate: "",
  status: "",
  emergencyContact: "",
  emergencyContactCode: "+91", // Default country code
  specimenESignature: "",
  
  // System Access
  username: "",
  password: "",
  confirmPassword: "",
});

export const resetForm = (setFormData: React.Dispatch<React.SetStateAction<{[key: string]: string}>>) => {
  setFormData(getInitialFormData());
};
